export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid transparent',
    '& [class*="actions"]': {
      opacity: '0',
      transition: 'all 0.3'
    },
    '& [class*="menuOpen"]': {
      opacity: '1 !important',
      transition: 'all 0.3'
    },
    '& [class*="selector"]': {
      opacity: '0',
      transition: 'all 0.3'
    },
    '&:hover': {
      border: `1px solid ${theme.colors.grey[100]}`,
      '& [class*="actions"]': {
        opacity: '1'
      },
      '& [class*="selector"]': {
        opacity: '1'
      }
    }
  },
  selected: {
    border: `1px solid ${theme.colors.actionMajor[500]} !important`,
    boxShadow: `0px 4px 10px ${theme.colors.actionMajor[500]}`
  },
  header: {
    width: '100%',
    height: '40px'
  },
  content: {
    width: '100%',
    height: 'calc(100% - 40px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  withFooter: {
    height: 'calc(100% - 92px)'
  },
  expanded: {
    width: '100%',
    height: '100%'
  },
  footer: {
    width: '100%',
    height: '32px',
    marginTop: '8px',
    paddingTop: '12px',
    borderTop: `1px solid ${theme.colors.grey[100]}`
  }
});